import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, Optional } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FieldDestinations, NO_DESTINATIONS, OrderField } from './order-field-destinations';
import { OrderFieldDestinationService } from './order-field-destination.service';

/**
 * Shows where an order form field is used: "PDF" and/or "Free vacancies".
 * Place it inside a field label, or pass `label` to render it as a caption above a widget.
 * Renders nothing outside the order form (no OrderFieldDestinationService provided).
 */
@Component({
  selector: 'app-field-destination',
  templateUrl: './field-destination.component.html',
  styleUrls: ['./field-destination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldDestinationComponent implements OnChanges {
  @Input() field: OrderField;
  @Input() label: string;

  destinations$: Observable<FieldDestinations> = of(NO_DESTINATIONS);

  @HostBinding('class.field-destination--caption')
  get isCaption() { return !!this.label; }

  constructor(@Optional() private fieldDestinations: OrderFieldDestinationService) {}

  ngOnChanges(): void {
    this.destinations$ = this.fieldDestinations && this.field
      ? this.fieldDestinations.destinations(this.field)
      : of(NO_DESTINATIONS);
  }
}
